module.exports = __webpack_public_path__ + "static/media/next-steps-bg.9e5e9a06.png";